(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../checkbox"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../checkbox"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.checkbox);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _checkbox) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _checkbox = _interopRequireDefault(_checkbox);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-agree",
        class: [_vm.disabled ? 'disabled' : '']
      }, [_c('div', {
        staticClass: "nx-agree-container"
      }, [_c('nx-checkbox', {
        attrs: {
          "hasCheck": _vm.hasCheck,
          "disabled": _vm.disabled
        },
        on: {
          "click": _vm.$_onChange
        },
        model: {
          value: _vm.value,
          callback: function callback($$v) {
            _vm.value = $$v;
          },
          expression: "value"
        }
      }, [_vm._t("default")], 2)], 1)]);
    },
    name: 'nx-agree-button',
    components: (0, _defineProperty2.default)({}, _checkbox.default.name, _checkbox.default),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      hasCheck: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {};
    },
    methods: {
      // MARK: events handler, 如 $_onButtonClick
      $_onChange: function $_onChange() {
        if (this.disabled) {
          return;
        }

        this.$emit('input', !this.value);
        this.$emit('change', !this.value);
      }
    }
  };
  _exports.default = _default;
});